import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from "react-redux";
import store from "./store/Store";


// initial load from flow:
//import './service/flowengine/FlowEngineAPI'

import './localization/i18n'



// dynamically load flow definition file
//import { loadFlowDefinition } from './service/flowengine/FlowEngineAPI'
//await loadFlowDefinition("FlowDefinitionICEngine");
//.then( () => {

  //
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={ store }>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
//})


